import React from "react";
import { Link } from "react-router-dom";

const AccountSidebar = () => {
  const options = [
    { name: "My Profile", path: "/my-profile" },
    { name: "Balance Overview", path: "/balance-overview" },
    { name: "Account Statement", path: "/account-statement" },
    { name: "Bet History", path: "/bet-history" },
    { name: "Log Out", path: "/log-out" },
  ];
  return (
    <div className="account  h-[100vh] ">
      <div className="account-sidebar w-[280px] ">
        <div className="account-subb ml-[50px] shadow-md hover:shadow-lg bg-[#fff]">
          <div className="bg-black text-white text-end px-2">My Accounts</div>
          <ul className="list_account ">
            {options.map((option) => (
              <li
                key={option.path}
                className="hover:bg-[#f9e8ba] font-normal border border-solid border-1 border-color:#f0ece1"
              >
                <Link to={option.path}>{option.name}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AccountSidebar;
